import { render, staticRenderFns } from "./InjectList.vue?vue&type=template&id=fc6f3530"
import script from "./InjectList.vue?vue&type=script&lang=js"
export * from "./InjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports